import { useEffect } from 'react';
import { useFetcher } from 'react-router';
import { Box, CircularProgress } from '@mui/material';

/**
 * LogoutPage : Déclenche l'action logout et affiche un loading
 *
 * Cette page est affichée quand l'utilisateur clique sur "Se déconnecter"
 * Elle déclenche l'action logoutAction et affiche un spinner pendant le logout
 */
export const LogoutPage = () => {
  const fetcher = useFetcher();

  // Auto-submit au montage via React Router fetcher
  // Cela assure que la soumission est correctement interceptée par React Router
  // et envoyée à l'action handler (pas directement au serveur)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // Note: fetcher intentionally omitted from deps to run submit only once on mount.
  // Adding fetcher would cause re-submissions if fetcher instance changes.
  useEffect(() => {
    fetcher.submit({}, { action: '/account/logout', method: 'post' });
  }, []);

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh'
    }}>
      {/* Loading spinner visible pendant le logout */}
      <CircularProgress />
    </Box>
  );
};
